module.exports = __webpack_public_path__ + "static/media/ts.514b0bfd.svg";